import { ReactElement } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { ContentLabelField, TextField } from '@hopskipdrive/react-components';
import * as Yup from 'yup';

interface KustomerUrlFieldProps {
  defaultValue?: string;
}

export const kustomerUrlValidation = Yup.string()
  .optional()
  .url('Kustomer ticket link must be a valid URL')
  .default('');

export const KustomerUrlField = ({ defaultValue }: KustomerUrlFieldProps): ReactElement => {
  const { control } = useFormContext();
  const { field, fieldState } = useController({
    name: 'kustomerUrl',
    control,
    defaultValue,
  });

  return (
    <ContentLabelField
      id="kustomerUrl"
      title="Kustomer link"
      editMode={true}
      editView={
        <TextField
          fullWidth
          variant={'outlined'}
          autoComplete="off"
          value={field.value || null}
          onChange={field.onChange}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          placeholder="Enter link to Kustomer ticket"
        />
      }
    />
  );
};
